var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatisticIconUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.29 6C17.4449 6 17.0217 7.02172 17.6193 7.61927C17.9897 7.98971 17.9897 8.59029 17.6193 8.96073L15.4093 11.1707C14.3051 12.2749 12.5149 12.2749 11.4107 11.1707C10.306 10.066 8.51465 10.0666 7.41067 11.172L2.70429 15.8848C2.31524 16.2743 2.31546 16.9055 2.70476 17.2948C3.09425 17.6843 3.72575 17.6843 4.11524 17.2948L7.4092 14.0008C8.51421 12.8958 10.3058 12.8958 11.4108 14.0008C12.5152 15.1052 14.3055 15.1059 15.4108 14.0024L19.0391 10.3798C19.4097 10.0098 20.01 10.01 20.3803 10.3803C20.978 10.978 22 10.5547 22 9.70947V7.75736C22 6.7868 21.2132 6 20.2426 6H18.29Z",
    fill: "#00B69B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticIconUp);
export default __webpack_public_path__ + "static/media/statistic_icon_up.623663b3f728da979e3f03c9a69d3fcd.svg";
export { ForwardRef as ReactComponent };